module.exports = __webpack_public_path__ + "img/route-marker-end.4355edf0.svg";